type ShouldLogFunction = () => boolean;

let shouldLog: ShouldLogFunction | undefined;

const onLogErrorHandlers = new Set<(message: string) => void>();

export function onLogError(func: (message: string) => void) {
    onLogErrorHandlers.add(func);
}

export function setShouldLog(newShouldLog: ShouldLogFunction | undefined): void {
    shouldLog = newShouldLog;
}

export function logInfo(...args: unknown[]): void {
    if (shouldLog === undefined || !shouldLog()) return;
    // eslint-disable-next-line no-console
    console.log(...args);
}

function callErrorHandlers(formatted: string): void {
    for (const handler of onLogErrorHandlers.values()) {
        try {
            handler(formatted);
        } catch (e: unknown) {
            // eslint-disable-next-line no-console
            console.error(`Calling handler for logError: ${e}`);
        }
    }
}

export function logError(...args: unknown[]): void {
    const formatted = args.map(x => `${x}`).join(" ");
    // eslint-disable-next-line no-console
    console.error(...args); // We pass the args in directly so that you can inspect
    callErrorHandlers(formatted);
}

export function logTrace(...args: unknown[]): void {
    const formatted = args.map(x => `${x}`).join(" ");
    // eslint-disable-next-line no-console
    console.trace(...args); // We pass the args in directly so that you can inspect
    callErrorHandlers(formatted);
}

export function logDebugger(...args: unknown[]): void {
    debugger;
    logError(...args);
}
